"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var _default = function _default() {
  var playerTool = undefined;
  /**
   * 设置播放工具
   * @param tool
   */

  var setPlayerTool = function setPlayerTool(tool) {
    playerTool = tool;
  };

  var start = function start(params) {
    playerTool && playerTool.prepare(params).then(function () {
      playerTool.start([0], params);
    });
  };

  var stop = function stop() {
    playerTool && playerTool.stop();
  };

  var setPlayMode = function setPlayMode(mode) {
    playerTool && playerTool.setPlayMode(mode);
  };
  /**
   * 点选播放
   * @param range
   */


  var openAreaSelectionPlay = function openAreaSelectionPlay(range, params) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _playerTool, state;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (playerTool) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", 'destroyed');

            case 2:
              _playerTool = playerTool, state = _playerTool.state;
              console.log("openAreaSelectionPlay ".concat(state));

              if (!(state === 'prepare' || state == 'destroyed')) {
                _context3.next = 9;
                break;
              }

              _context3.next = 7;
              return playerTool.prepare(params).then(function () {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
                  return _regenerator.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          playerTool.start(range, params);

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
              });

            case 7:
              _context3.next = 15;
              break;

            case 9:
              if (!(state === 'stop' || state === 'start' || state === 'continue')) {
                _context3.next = 14;
                break;
              }

              _context3.next = 12;
              return playerTool.setConfParams(params).then(function (res) {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                  return _regenerator.default.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          res && playerTool.start(range, params);

                        case 1:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));
              });

            case 12:
              _context3.next = 15;
              break;

            case 14:
              if (state === 'pause') {
                playerTool.continue(range, params);
              }

            case 15:
              return _context3.abrupt("return", playerTool.state);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  };

  var playerCallBack = function playerCallBack(callbackEventStr) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return playerTool.playerCallBack(callbackEventStr);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  };

  return {
    setPlayerTool: setPlayerTool,
    start: start,
    stop: stop,
    setPlayMode: setPlayMode,
    openAreaSelectionPlay: openAreaSelectionPlay,
    playerCallBack: playerCallBack
  };
};

exports.default = _default;